const dates = [
    ["Today", 1],
    ["This Week", 11],
    ["Custom Date", 12]
]

export default dates